'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clientLibrary = require('@seneca/client-library');
/**
 * Error when try to update/delete a tag which does not exist
 * @param {string} id the tag id
 */


var NumberOfTagChildrenCannotBeAlteredError =
/*#__PURE__*/
function (_clientLibrary$Extend) {
  _inherits(NumberOfTagChildrenCannotBeAlteredError, _clientLibrary$Extend);

  function NumberOfTagChildrenCannotBeAlteredError() {
    _classCallCheck(this, NumberOfTagChildrenCannotBeAlteredError);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberOfTagChildrenCannotBeAlteredError).call(this, "Number of tag children cannot be altered"));
  }

  return NumberOfTagChildrenCannotBeAlteredError;
}(_clientLibrary.ExtendableError);

exports.default = NumberOfTagChildrenCannotBeAlteredError;